// extracted by mini-css-extract-plugin
module.exports = {"container":"number-bullet_container__5qCJK"};